import { BasicPage } from "../components/BasicPage";
import Person from "@mui/icons-material/Person";

const ProfilePage = () => {
  return <BasicPage title="Profile Page" icon={<Person />} />;
};

export default ProfilePage;
